// import { Viewer } from "@nova/constants"
import { flattenSubTags } from "@nova/util-tag-tree"
import { Builder } from "."
import { SocketSlice } from "./types"
import {
    fetchExtendedWorkspace,
    // addViewerToTag,
    // removeViewerFromTag,
} from "features/data-management/workspace/WorkspaceManagementSlice"

export default {
    handlers: (builder: Builder) =>
        builder.addCase(fetchExtendedWorkspace.fulfilled, (_, action, socket) => {
            const item = action.payload.organization
            const tags = flattenSubTags(item.tags)
            tags.forEach((item: { id: string }) => {
                socket.emit("subscribe", item.id, "tag")
            })
        }),
    events: {
        // tag: (store) => (id: string, user: Viewer) => {
        //     store.dispatch(addViewerToTag({ user, id }))
        // },
        // leavetag: (store) => (id: string, user: Viewer) => {
        //     store.dispatch(removeViewerFromTag({ user, id }))
        // },
    },
} as SocketSlice
